(() => {
  if (window.TERecommendations) return;
  window.TERecommendations = true;

  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = root + 'cart.js';
  let cartPromise;
  const getCart = () => (cartPromise ||= fetch(cartUrl, { headers: { Accept: 'application/json' } }).then(response => response.ok ? response.json() : null).catch(() => null));
  const reserveLoads = new WeakMap();

  async function loadReserves(section, grid) {
    if (section.dataset.teDeferredReserves !== 'true' || section.dataset.teReservesLoaded === 'true') return;
    if (!reserveLoads.has(section)) {
      const url = new URL(location.href);
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', section.dataset.sectionId);
      const request = fetch(url, { headers: { Accept: 'text/html' } })
        .then(response => {
          if (!response.ok) throw new Error('Recommendations section unavailable');
          return response.text();
        })
        .then(markup => {
          if (!section.isConnected) return;
          const html = new DOMParser().parseFromString(markup, 'text/html');
          const fullGrid = html.querySelector('[data-te-recommendations-grid]');
          if (!fullGrid) throw new Error('Recommendations grid unavailable');
          const existing = new Set(Array.from(grid.children, item => item.dataset.teProductId));
          fullGrid.querySelectorAll('[data-te-product-id]').forEach(item => {
            if (!existing.has(item.dataset.teProductId)) grid.append(document.importNode(item, true));
          });
          section.dataset.teReservesLoaded = 'true';
        })
        .catch(() => { reserveLoads.delete(section); });
      reserveLoads.set(section, request);
    }
    await reserveLoads.get(section);
  }

  async function update(section) {
    if (!section.isConnected) return;
    const grid = section.querySelector('[data-te-recommendations-grid]');
    if (!grid) return;
    if (!grid.children.length && section.dataset.recommendationsUrl) {
      const url = new URL(section.dataset.recommendationsUrl, location.origin);
      url.searchParams.set('section_id', section.dataset.sectionId);
      url.searchParams.set('product_id', section.dataset.productId);
      url.searchParams.set('limit', section.dataset.limit || '4');
      url.searchParams.set('intent', section.dataset.intent === 'alternative' ? 'related' : 'complementary');
      try {
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (response.ok) {
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = html.querySelector('[data-te-recommendations-grid]');
          if (next) grid.replaceChildren(...Array.from(next.children).map(item => document.importNode(item, true)));
        }
      } catch (_) { /* Manual selections remain available without recommendations. */ }
    }
    const cart = await getCart();
    if (!cart) return;
    const inCart = new Set(cart.items.map(item => String(item.product_id)));
    let visibleCount = 0;
    const limit = Number(section.dataset.limit) || 4;
    const availableCount = Array.from(grid.querySelectorAll('[data-te-product-id]')).filter(item => !inCart.has(item.dataset.teProductId)).length;
    if (availableCount < limit) await loadReserves(section, grid);
    grid.querySelectorAll('[data-te-product-id]').forEach(item => {
      const show = !inCart.has(item.dataset.teProductId) && visibleCount < limit;
      item.hidden = !show;
      if (show) visibleCount += 1;
    });
    section.hidden = !grid.querySelector('[data-te-product-id]:not([hidden])');
  }

  function init(scope = document) {
    const sections = scope.querySelectorAll('[data-te-recommendations]:not([data-te-initialized])');
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          update(entry.target);
        }
      });
    }, { rootMargin: '450px' }) : null;
    sections.forEach(section => {
      section.dataset.teInitialized = 'true';
      if (!section.querySelector('[data-te-recommendations-grid]')?.children.length) update(section);
      else if (observer) observer.observe(section);
      else update(section);
    });
  }

  const refreshForCart = () => {
    cartPromise = null;
    document.querySelectorAll('[data-te-recommendations][data-te-initialized]').forEach(update);
  };
  document.addEventListener('theme:cart:refresh', refreshForCart);
  document.addEventListener('theme:cart:added', refreshForCart);
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
